const rowTypes = Object.freeze({
    header: Symbol('header'),
    filter: Symbol('filter'),
    body: Symbol('body')
});

export default rowTypes;
